/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PurchaseRateIssueDTOFromJSON, PurchaseRateIssueDTOToJSON, } from './PurchaseRateIssueDTO';
import { PurchaseRateDTOFromJSON, PurchaseRateDTOToJSON, } from './PurchaseRateDTO';
/**
 * Check if a given object implements the PurchaseSubmitResponse interface.
 */
export function instanceOfPurchaseSubmitResponse(value) {
    return true;
}
export function PurchaseSubmitResponseFromJSON(json) {
    return PurchaseSubmitResponseFromJSONTyped(json, false);
}
export function PurchaseSubmitResponseFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'submitted': json['submitted'] == null ? undefined : json['submitted'],
        'slOrderId': json['slOrderId'] == null ? undefined : json['slOrderId'],
        'autoSelected': json['autoSelected'] == null ? undefined : json['autoSelected'],
        'carrierName': json['carrierName'] == null ? undefined : json['carrierName'],
        'carrierService': json['carrierService'] == null ? undefined : json['carrierService'],
        'totalPrice': json['totalPrice'] == null ? undefined : json['totalPrice'],
        'currency': json['currency'] == null ? undefined : json['currency'],
        'rates': json['rates'] == null ? undefined : (json['rates'].map(PurchaseRateDTOFromJSON)),
        'issues': json['issues'] == null ? undefined : (json['issues'].map(PurchaseRateIssueDTOFromJSON)),
        'currentRate': json['currentRate'] == null ? undefined : PurchaseRateDTOFromJSON(json['currentRate']),
        'currentSlOrderId': json['currentSlOrderId'] == null ? undefined : json['currentSlOrderId'],
    };
}
export function PurchaseSubmitResponseToJSON(json) {
    return PurchaseSubmitResponseToJSONTyped(json, false);
}
export function PurchaseSubmitResponseToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'submitted': value['submitted'],
        'slOrderId': value['slOrderId'],
        'autoSelected': value['autoSelected'],
        'carrierName': value['carrierName'],
        'carrierService': value['carrierService'],
        'totalPrice': value['totalPrice'],
        'currency': value['currency'],
        'rates': value['rates'] == null ? undefined : (value['rates'].map(PurchaseRateDTOToJSON)),
        'issues': value['issues'] == null ? undefined : (value['issues'].map(PurchaseRateIssueDTOToJSON)),
        'currentRate': PurchaseRateDTOToJSON(value['currentRate']),
        'currentSlOrderId': value['currentSlOrderId'],
    };
}
